import { Injectable } from "@angular/core";

export enum KioskLocalStorageKeysEnum {
  REFRESH_TOKEN = "kioskRefreshToken",
  ID_TOKEN = "kioskIdToken",
  ROOM_ID = "roomId",
  HOUR_FORMAT = "hourFormat",
  REFRESH_ATTEMPTS = "refreshAttempts",
  PLATFORM = "platform",
}

@Injectable({
  providedIn: "root",
})
export class LocalStorageService {
  private readonly localStorage = localStorage;

  setItem(key: string, data: string) {
    this.localStorage.setItem(key, data);
  }

  getItem(key: string): string | null {
    return this.localStorage.getItem(key);
  }

  removeItem(key: string): void {
    this.localStorage.removeItem(key);
  }

  clearStorage(): void {
    this.localStorage.clear();
  }

  clearTokens(): void {
    this.localStorage.removeItem(KioskLocalStorageKeysEnum.REFRESH_TOKEN);
    this.localStorage.removeItem(KioskLocalStorageKeysEnum.ID_TOKEN);
    this.localStorage.removeItem(KioskLocalStorageKeysEnum.ROOM_ID);
  }
}
